export const TITLE = 'Your finance agreement is in place';

export const REDIRECT_TITLE = 'Your finance agreement is in place';

export const INTRODUCTION_TITLE =
  'Your finance agreement for your order is in place';

export const SUBTITLE_STANDARD = [
  '',
  '$partner',
  ' have been notified that your agreement is in place and they can co-ordinate with you to undertake your job.',
];

export const SUBTITLE_SUPPLY = [
  '',
  '$partner',
  ' have been notified that your agreement is in place and they can co-ordinate with you to deliver your goods.',
];

export const REDIRECT_SUBTITLE = [
  'You will need to return to ',
  '$partner',
  "'s site to confirm your order with them",
];

export const LINE_2_STANDARD =
  'Upon completion of the job, you will be asked to sign a satisfaction note, confirming the job has been completed and you are happy with the work undertaken.';

export const LINE_2_SUPPLY =
  'Upon delivery of your goods, you will be asked to sign a satisfaction note, confirming the delivery and that you are happy with the delivered goods.';

export const LINE_3 =
  'Your monthly repayments will only start once you haved signed the satisfaction note.';

export const CLASS_NAMES = {
  title:
    'text-14-22-em text-purple-400 md:text-20-24-em mb-3 mt-3 md:mb-6 md:mt-4',
  subtitle: 'text-14-22 text-neutral-600 mb-2 md:mb-4',
};

export const ICON_PROPS = {
  size: 24,
  stroke: 'neutral-700',
  icon: 'check-circle-color',
};
